
// Bulk add to cart script
var scriptElement = $("#wx-variants-data");
var sizesWrapper = $(".product-form__input-size");
if($(".product-form__input-size").length < 1){
  sizesWrapper = $(".product-form__input-grosse");
}
var result = {};


$(function(){
  
  if (scriptElement.length) {
      sizesWrapper.find("input.netterms-qty").remove();
      try {
          var jsonData = JSON.parse(scriptElement.text());

          jsonData.forEach(function(item) {
            console.log(item);
              var option1 = item.option1;
              if (!result[option1]) {
                  result[option1] = [];
              }
              result[option1].push({
                  id: item.id,
                  option2: item.option2,
                  price: item.price,
                  available: item.available
              });

              // append the sizes input
              var singleSize  = sizesWrapper.find('[data-value="'+item.option2+'"]');
              if(singleSize.length > 0){
                var input = '<input type="number" class="wx-variant-qty netterms-qty" data-value="'+item.option2+'" data-option="option2" data-color="'+item.option1+'" data-size="'+item.option2+'" data-productid="'+item.id+'" min="0" step="1">';
                singleSize.append(input);
              }
          });
          showSizes();
      } catch (error) {
          console.error("Error parsing JSON:", error);
      }
  } else {
      console.error("Script element with ID 'wx-variants-data' not found.");
  }
});

// show sizes on color change
$(document).on('click' , '.product-form__input-color[data-option="option1"] .form-variant-option-wrap', showSizes);
$(document).on('click' , '.product-form__input-farbe[data-option="option1"] .form-variant-option-wrap', showSizes);
function showSizes(){ 
  if($(".product-form__input-size").length < 1){
  if($('.product-form__input-farbe input[name="Farbe"]:checked').length){
    var colorWrapper = $('.product-form__input-farbe input[name="Farbe"]:checked').parent('.form-variant-option-wrap');
    var color  = colorWrapper.data("value");
    sizesWrapper.find('input.wx-variant-qty').hide();
    sizesWrapper.find('input.wx-variant-qty[data-color="'+color+'"]').show();
  }    
  } else{
  if($('.product-form__input-color input[name="Color"]:checked').length){
    var colorWrapper = $('.product-form__input-color input[name="Color"]:checked').parent('.form-variant-option-wrap');
    var color  = colorWrapper.data("value");
    sizesWrapper.find('input.wx-variant-qty').hide();
    sizesWrapper.find('input.wx-variant-qty[data-color="'+color+'"]').show();
  }
  }
}

var root_url = "";
var saved_qty = {};

function multiAdd(keys) {
  if (keys.length) {
    var request = keys.shift(),
        temp = request,
        params = {
          type: 'POST',
          url: root_url +'/cart/add.js',
          data: temp,
          dataType: 'json',
          success: function(line_item) {
            setTimeout(function(){
              multiAdd(keys);
            },1500)
          },
          error: function(jqXHR, status, err) {
            console.log(jqXHR);
            console.log(status);
            console.log(err);
            setTimeout(function(){
              multiAdd(keys);
            },1500)
          }
        };
    $.ajax(params);
  } else {
    window.location = window.routes.cart_url;
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      console.log('starting mac');
      if(this.form.classList.contains('multi-add')){

        console.log('found mac');
        
        var key_array = [],
            key_object = {},
            props = {},
            count = Object.keys(saved_qty).length,
            productSingleObject = JSON.parse(this.querySelector('[type="application/json"]').textContent),
            product_variants = productSingleObject.variants,
            qty_total = window.shop.infos.cart.item_count;
        $.each(saved_qty,function(i,v){
          qty_total += v
        });
        console.log(window.shop.infos.cart);
        console.log(window.shop.infos.cart.item_count);
        console.log('count:'+count);
        console.log('qty total:'+qty_total);
        var shippingJson = JSON.parse(document.getElementById('shippingJSON').innerHTML),
            attributes = {};
        $.each(shippingJson.country,function(country,provinces){
          $.each(provinces[0],function(province,shipping_types){
            var key_string_single = 'shipping_single_'+ country +'_'+ province,
                key_string_multiple = 'shipping_multiple_'+ country +'_'+ province;
            attributes[key_string_single] = shipping_types[0]['single'];
            attributes[key_string_multiple] = shipping_types[0]['multiple'];
          });
        });
        $.each(saved_qty, function(variant,qty){
          var find_variant = $.grep(product_variants, function (element, index) {
                return element.id == variant;
              });
          var finalprice = variantsnetavailInventory.find((el) => el.variantid == find_variant[0].id).b2bprice,
              ffcents = finalprice.toFixed(0);
              const dataHandle = document.querySelector('.wx-phandle').getAttribute('data-handle');
          if(Cookies.get('netneed') == 'net_now' || Cookies.get('netneed') == 'net_preorder') {
            props = {'NETPRICE':ffcents, 'PREORDER': Cookies.get('netneed') == 'net_preorder' ? 'true' : 'false', 'Product Handle': dataHandle, 'Product Color': variantsnetavailInventory.find((el) => el.variantid == find_variant[0].id).b2bcolor, 'Variant ID': find_variant[0].id, 'Variant Price': find_variant[0].price, 'Variant Max Qty': variantsnetavailInventory.find((el) => el.variantid == find_variant[0].id).b2bqty }
          } else {
            props = {'NETPRICE':ffcents}
            $.extend( true, props, attributes );
          }
          if(window.shop.infos.domain.includes('us')){
            var poid = 45622363455645;
          }else if(window.shop.infos.domain.includes('eu')){
            var poid = 49319405748565;
          }else{
            var poid = 39297132789897;
          }
          
          key_object = {
            id: Cookies.get('netneed') != 'net_dropship' ? poid : find_variant[0].id,
            quantity: qty,
            properties: props
          };
            console.log(key_object);
          key_array.push(key_object);
          if (!--count && key_array.length > 0) {
            console.log('key_array:',key_array);
            multiAdd(key_array);
          }
        });
        
      }else{

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
  
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
  
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
  
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
  
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            const shopTheLookModal = this.closest('modal-dialog');
            if (quickAddModal || shopTheLookModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              if (quickAddModal) {
                quickAddModal.hide(true);
              } else {
                shopTheLookModal.hide(true);
              }
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    multiItemAdd() {
      
    }
  });
}


